import styled from '@emotion/styled'

export const ImageContainer = styled('div')`
  position: relative;
`
